const EMAIL_REGEX = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

export const getIsValidEmail = (value: string): boolean => EMAIL_REGEX.test(value);
